<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">  
      <rect width="101.75" height="512" rx="12.99"/>
      <rect width="101.75" height="512" x="136.75" rx="12.99"/>
      <rect width="101.75" height="512" x="273.5" rx="12.99"/>
      <rect width="101.75" height="512" x="410.25" rx="12.99"/>
	</svg>
</template>